import { trpc, TrpcInputs, TrpcOutputs } from '../../config/trpc';
import { UseResource } from '../../utils/types';

type AccountsOutput = TrpcOutputs['getAccounts'][1];
type UseAccounts = UseResource<AccountsOutput, never, never> & {
  count?: number;
  refetch: () => void;
};

export const useAccounts = (queryParams: TrpcInputs['getAccounts']): UseAccounts => {
  const { isLoading, data, error, refetch } = trpc.getAccounts.useQuery(queryParams, {
    refetchOnWindowFocus: false,
  });

  const itemCount = data?.[0];
  const items = data?.[1];

  return {
    data: items,
    count: itemCount,
    isLoading,
    error: error?.message,
    refetch,
  };
};
